import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_LOCATION = 'GET_LOCATION';
export const GET_LOCATION_SUCCESS = 'GET_LOCATION_SUCCESS';
export const GET_LOCATION_FAILURE = 'GET_LOCATION_FAILURE';

// Action Creators
export const getLocation = () => ({
  type: GET_LOCATION,
});

export const getLocationSuccess = (data) => ({
  type: GET_LOCATION_SUCCESS,
  payload: data,
});

export const getLocationFailure = (error) => ({
  type: GET_LOCATION_FAILURE,
  payload: error,
});

// Thunk Function
export const getLocationCallAPI = (data, external, search = '') => {
  return async (dispatch) => {
    dispatch(getLocation());
    try {
      const response = await getMethodWithToken(
        url.staff +
          data +
          '/locations/' +
          (search ? `?search_text=${search}` : '')
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getLocationSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getLocationFailure(error?.message));
    }
  };
};
